document.addEventListener('DOMContentLoaded', () => {
const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
};

const fadeObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
    if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); 
    }
    });
}, observerOptions);

document.querySelectorAll('.animate-in').forEach(element => {
    fadeObserver.observe(element);
});
console.log('testing');
});

